import React from 'react';
import { Card } from 'react-bootstrap';
import { timeConverter } from './../../utils/NiceStrings'


const IssuesCard = ({ title, issues }) => {

    const statusPill = (issue) => {
        let mode = "info";
        //'New', 'InProgress', 'Reopened', 'NextUp', 'WaitingOnPlayer', 'PlayerResponded'
        switch (issue.issue_status) {
            case 'WaitingOnPlayer':
                mode = 'warning';
                break;
            case 'Backlog':
                mode = 'success';
                break;
            case 'InProgress':
                mode = 'success';
                break;
            case 'New':
                mode = 'danger';
                break;

        }

        return (
            <span className={"mx-1 px-2 badge text-bg-" + mode}>
                {issue.issue_type}
            </span>
        );
    }

    return (
        <Card className={"m-2 score-card-eom-overview"} >
            <Card.Header className={"going-on-header"}>
                <Card.Title>{title}</Card.Title>
            </Card.Header>
            <Card.Body>
                {issues.map((issue, index) =>
                    <div key={index} className="divtext pb-2">
                        <a className="dryLink" href={`/builder/issues/${issue.issue_id}`}>
                            {statusPill(issue)}
                            <small>{issue.issue_type} {issue.issue_id} {issue.issue_reporter} - {timeConverter(issue.issue_updated)}</small>
                            <br />
                            <div className={"issue-span"}>
                                <span>{issue.issue_description}</span>

                            </div>

                        </a>

                        <br></br>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
}

export default IssuesCard;